import {
  GET_ARCHIVED_RECORDS_SUCCESS, GET_MATERIAL_RECORDS_FAILURE, GET_MATERIAL_RECORDS_REQUEST, GET_MATERIAL_RECORDS_SUCCESS, RECORD_UNARCHIVED_SUCCESS, RESET_LAST_VISIBLE
} from "../actions/";

const record = (
  state = {
    // initial state
    records: [],
    archivedRecords: [],
    isGettingRecords: true,
    getRecordsError: "",
    isRecordUnArchived: false,
    lastVisible: null,
  },
  action
) => {
  switch (action.type) {
    case GET_MATERIAL_RECORDS_SUCCESS:
      return {
        ...state,
        records: action.records,
        isGettingRecords: false,
        isRecordUnArchived: false,
      };
    case GET_ARCHIVED_RECORDS_SUCCESS:
      return {
        ...state,
        archivedRecords: action.records,
        lastVisible: action.lastVisible,
        isRecordUnArchived: false,
      };
    case GET_MATERIAL_RECORDS_REQUEST:
      return {
        ...state,
        isGettingRecords: true,
        getRecordsError: "",
      };
    case GET_MATERIAL_RECORDS_FAILURE:
      return {
        ...state,
        getRecordsError: action.error,
        isGettingRecords: false,
      };
    case RECORD_UNARCHIVED_SUCCESS:
      return {
        ...state,
        isRecordUnArchived: true,
        archivedRecords: []
      };

    case RESET_LAST_VISIBLE:
      return {
        ...state,
        lastVisible: null,
      };
    default:
      return state;
  }
};

export default record;
